<template>
	<div class="content">
		<h3>包装比例设置</h3>
		<div class="item">
			<div class="btn">
				<el-button icon="el-icon-plus" type="primary" @click="AddPack">添加</el-button>
				<el-button icon="el-icon-search" type="primary" @click="SelPack">查询</el-button>
				<el-button type="primary">导出</el-button>
			</div>
			<el-form :inline="true" style="width:auto" label-width="80px">
				<el-form-item label="包装层级">
					<el-select v-model="packlev" clearable placeholder="请选择">
						<el-option
						v-for="item in level"
						:key="item.value"
						:label="item.value"
						:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
		</div>
		<div class="item">
			<el-table :data="tableData" border>
				<el-table-column prop="Level" label="包装层级"></el-table-column>
				<el-table-column prop="Scale" label="比例表达式"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button type="text" @click="EditPack(scope)">修改</el-button>
						<el-button type="text" @click="delPack(scope)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog :title="dialogtype==1 ? '添加包装比例':'编辑包装比例'" @close="close" :visible.sync="dialogVisible" width="740px">
      		<el-form ref="packform" inline style="width:500px" :model="packform" :rules="rules" label-width="100px">
				<el-form-item label="包装编码" prop="Psid">
					<el-input v-model="packform.Psid"></el-input>
				</el-form-item>
				<el-form-item label="包装层级" prop="Level">
                    <el-select v-model="packform.Level" @change="setLev" placeholder="请选择">
						<el-option
						v-for="item in level"
						:key="item.value"
						:label="item.value"
						:value="item.value">
						</el-option>
					</el-select>
                </el-form-item>
				<el-form-item v-if="packform.Level>=1"  label="一级包装数量" >
					<el-input :disabled="packform.Level>1" v-model="lev1" @change="SetScale"></el-input>
				</el-form-item>
				<el-form-item v-if="packform.Level>=2" label="二级包装数量" >
					<el-input  @change="SetScale" v-model="lev2"></el-input>
				</el-form-item>
				<el-form-item v-if="packform.Level>=3" label="三级包装数量" >
					<el-input  @change="SetScale" v-model="lev3"></el-input>
				</el-form-item>
				<el-form-item  v-if="packform.Level==4"  label="四级包装数量" >
					<el-input  @change="SetScale" v-model="lev4"></el-input>
				</el-form-item>
				
				
				
				<el-form-item label="包装表达式" prop="Scale">
					<el-input :disabled="true" v-model="packform.Scale"></el-input>
				</el-form-item>
				<el-form-item label="状态">
					<el-radio v-model="packform.IsEnable" :label='1'>启用</el-radio>
  					<el-radio v-model="packform.IsEnable" :label='0'>禁用</el-radio>
				</el-form-item>
			</el-form>
      		<span slot="footer" class="dialog-footer">
        		<el-button @click="restForm" v-if="dialogtype==1" type="warning">重 置</el-button>
        		<el-button type="primary" @click="Setpackform">保 存</el-button>
      		</span>
    	</el-dialog>
	</div>
</template>

<script>
import {validateNumber} from '../utils/rules'
export default {
	data(){
		return {
			packform: {
				Level: 0,
				Psid: '',
				IsEnable: 1,
				Scale: null,
				cid:'',
				DataId:'0'
			},
			rules: {
				Psid:[
          			{ required: true, validator: validateNumber, message: '请输入包装编码，数字类型', trigger: 'change' }
        		],
        		Level:[
          			{ required: true, message: '请选择一个层级', trigger: 'change' }
        		],
        		Scale:[
          			{ required: true,  message: '请选择一个包装比例', trigger: 'blur' }
        		]
			},
			lev1:'',
			lev2:'',
			lev3:'',
			lev4:'',
			tableData: [],
			level:[{value:1},{value:2},{value:3},{value:4}],
			packlev:'',
			dialogVisible:false,
			dialogtype:0,
			editVisible:true,
		}
	},
	methods: {
		setLev() {
			this.lev1=1
			this.lev2=1
			this.lev3=1
			this.lev4=1
			this.SetScale()
		},
		SetScale(){
			if(this.packform.Level == 1){
				this.packform.Scale=this.lev1
			}else if(this.packform.Level == 2){
				this.packform.Scale=this.lev1+"*"+this.lev2
			}else if(this.packform.Level == 3){
				this.packform.Scale=this.lev1+"*"+this.lev2+"*"+this.lev3
			}else if(this.packform.Level == 4){
				this.packform.Scale=this.lev1+"*"+this.lev2+"*"+this.lev3+"*"+this.lev4
			}
		},
		SelPack(){
			var user = JSON.parse(sessionStorage.getItem('user'));
			//查询包装比例
			this.$axios({
        		method: 'post',
        		url:'/FW/Package.ashx',
        		params: {
          			action:"query",
					cid:user.QyNum,
					PLevel:this.packlev
        		}
        	}).then(res=>{
          		if(res.Code==0){
					this.tableData=res.DataList
          		}else{
					this.$message({
            			showClose: true,
            			message:res.Msg,
            			type: 'warning'
            		});
          		}       
      		})		
		},
		AddPack(){
			this.editVisible=false
			this.dialogVisible=true;
			this.dialogtype=1;
		},
		EditPack(scope){
			this.editVisible=true
			this.dialogVisible=true;
			this.dialogtype=2;
			this.$nextTick(() => {
				this.packform.Level=scope.row.Level;
				this.packform.Scale=scope.row.Scale;
				this.packform.IsEnable=scope.row.IsEnable;
				this.packform.DataId=scope.row.DataId;
				this.packform.cid=scope.row.Cid;
				this.packform.Psid=scope.row.Psid;
				let len = scope.row.Scale.split("*").length
				// this.lev1 = scope.row.Scale.split("*")
				if(len === 1){
					this.lev1 = scope.row.Scale.split("*")[0]
				}else if(len === 2){
					this.lev2 = scope.row.Scale.split("*")[0]
					this.lev1 = scope.row.Scale.split("*")[1]
				}else if(len === 3){
					this.lev3 = scope.row.Scale.split("*")[0]
					this.lev2 = scope.row.Scale.split("*")[1]
					this.lev1 = scope.row.Scale.split("*")[2]
				}else if(len === 4){
					this.lev4 = scope.row.Scale.split("*")[0]
					this.lev3 = scope.row.Scale.split("*")[1]
					this.lev2 = scope.row.Scale.split("*")[2]
					this.lev1 = scope.row.Scale.split("*")[3]
				}
			})
		},
		delPack(scope){
			this.$axios({
        				method: 'post',
        				url:'/FW/Package.ashx',
        			params: {
          				action:"delete",
          				package:scope.row
        			}
        			}).then(res=>{
          				if(res.Code==0){
							this.$message({
            				showClose: true,
            				message:res.Msg,
            				type: 'success'
							});
							this.SelPack()
          				}else{
							this.$message({
            					showClose: true,
            					message:res.Msg,
            					type: 'warning'
            				});
          				}       
      				})
		},
		close(){
			this.$refs['packform'].resetFields()
		},
		restForm(){
			this.$nextTick(()=>{
				this.$refs['packform'].resetFields()
			})
		},
		Setpackform(){
			this.$refs['packform'].validate((isValidate)=>{
				if(isValidate){
					var user = JSON.parse(sessionStorage.getItem('user'));
					this.packform.cid=user.QyNum
					if(this.dialogtype==1){
						//添加工厂
					this.$axios({
        				method: 'post',
        				url:'/FW/Package.ashx',
        			params: {
          				action:"add",
          				package:this.packform
        			}
        			}).then(res=>{
          				if(res.Code==0){
							this.$message({
            				showClose: true,
            				message:res.Msg,
            				type: 'success'
							});
							this.SelPack()
          				}else{
							this.$message({
            					showClose: true,
            					message:res.Msg,
            					type: 'warning'
            				});
          				}       
      				})
					}else if(this.dialogtype==2){
						//修改工厂
					this.$axios({
        				method: 'post',
        				url:'/FW/Package.ashx',
        			params: {
          				action:"edit",
          				package:this.packform
        			}
        			}).then(res=>{
          				if(res.Code==0){
							this.$message({
            				showClose: true,
            				message:res.Msg,
            				type: 'success'
							});
							this.SelPack()
          				}else{
							this.$message({
            					showClose: true,
            					message:res.Msg,
            					type: 'warning'
            				});
          				}       
      				})
					}
				}else{
					isValidate
				}
			})
		}
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}

.btn{
	width: 500px;
	margin:10px 80px;
}

</style>


// WEBPACK FOOTER //
// src/pages/settingPacking.vue